<template>
  <div>
    <Header :sel="1" @changePhone="changePhone"></Header>
    <div :class="['cd-main-content', showPhone ? 'nav-is-visible' : '']">
      <div class="bg1">
        <div class="main1">
          <div class="main1_l" style="position: relative">
            <el-carousel class="el-carousel" :interval="5000" height="30vw" indicator-position="none"
              @change="handleSlideChange">
              <el-carousel-item v-for="item in bannerList" :key="item.id">
                <div class="slide-content">
                  <img :src="item.url" class="slide-image" @click="goHref(item.href)" />
                </div>
              </el-carousel-item>
            </el-carousel>
            <div class="caption">
              <h2 class="title swiper-title-home" style="cursor: pointer" @click="goHref(bannerList[activeIndex].href)">
                {{ bannerList[activeIndex] && bannerList[activeIndex].bannerName }}
              </h2>
              <div class="custom-indicators">
                <div v-for="(items, indexs) in bannerList" :key="indexs" class="indicator-item"
                  :class="{ 'is-active': activeIndex === indexs }"></div>
              </div>
            </div>
          </div>
          <div class="main1_r">
            <div class="news_tab">
              <a href="javascript:void(0)" :class="item.categoryCode == selId ? 'sel' : ''" id="ps01"
                v-for="item in centerrightList" @click="pros_hover(item.categoryCode)">
                {{ item.categoryName }}
              </a>
              <div class="clear"></div>
            </div>
            <div class="more"><a href="javascript:void(0)" @click="goMore('/newList?level=1&type=' + selId)">更多>></a>
            </div>
            <div>
              <div class="main_c">
                <ul class="news_index_list">
                  <li v-for="item in newList">
                    <span>{{ item.publishTime }}</span>
                    <a href="javascript:void(0)" @click="goDetail(item.id, item.categoryName, item.linkUrl)">{{
                      item.title }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 学习贯彻党的二十届四中全会精神 -->
      <div class="ad">
        <img src="../assets/images/ershijiesizhong-xin.jpg" alt="" @click="goNewList(1, '12000')">
      </div>

      <!--企业文化-->
      <!--ad-->
      <!-- <div class="ad">
        <a href="https://www.xuexi.cn/" target="_blank"><img src="../assets/images/ad.png" /></a>
      </div>
      <div class="ad2">
        <a href="https://www.xuexi.cn/" target="_blank"><img src="../assets/images/ad2.png" /></a>
      </div> -->
      <!--ad-->

      <div v-if="showAd5" class="ad5" ref="ad5" @mouseover="handleMouseEnter" @mouseleave="handleMouseLeave">
        <img src="https://iaqd-web.oss-cn-qingdao.aliyuncs.com/2026-06-23/1782186233408309.jpg" @click="goAd" />
        <div class="close-btn" v-show="isHover" @click.stop="closeAd5">×</div>
      </div>

      <!--新闻中心-->
      <div class="bg2">
        <div class="main2">
          <div class="main2_child" v-for="item in bottomList">
            <div class="main2_t">
              <div class="main_line">&nbsp;</div>
              <span v-if="item.categoryCode == '30001'"><a href="javascript:void(0)"
                  @click="goMore('newList?level=1&type=10007')">更多</a></span>
              <span v-else><a href="javascript:void(0)"
                  @click="goMore('/newList?level=1&pos=bottom&type=' + item.categoryCode)">更多</a></span>
              {{ item.categoryName }}
            </div>
            <ul class="main_c_placeholder" v-if="detailLoading" v-loading="detailLoading">
              <li v-for="(item, index) in 6" :key="index"></li>
            </ul>
            <ul class="news_index_list" v-else>
              <li v-for="items in subNewsListMap[item.categoryCode]">
                <!-- <span>{{ items.publishTime }}</span> -->
                <a href="javascript:void(0)" @click="goDetail(items.id, item.categoryName, items.linkUrl)">{{
                  items.title
                }}</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="main4">
          <div class="main4_t">财产险公司</div>
          <div class="more"><a href="javascript:void(0)" @click="goMore('/companyList?memberType=1')">更多>></a></div>
          <div class="slider-wrapper">
            <ul class="logo_list slider">
              <li v-for="item in infoList1">
                <a :href="item.url" target="_blank"><img class="logo-img" :src="item.logo" /></a>
              </li>
            </ul>
          </div>
          <div class="main4_t">人身险公司</div>
          <div class="more"><a href="javascript:void(0)" @click="goMore('/companyList?memberType=2')">更多>></a></div>
          <div class="slider-wrapper">
            <ul class="logo_list slider">
              <li v-for="item in infoList2">
                <a :href="item.url" target="_blank"><img class="logo-img" :src="item.logo" /></a>
              </li>
            </ul>
          </div>
          <div class="main4_t">行业链接</div>
          <ul class="link_list">
            <a :href="item.url" target="_blank" v-for="item in companyList">{{ item.linkName }}</a>
          </ul>
        </div>
      </div>
      <Footer></Footer>
    </div>
    <!--main-->
    <a href="javascript:scroll(0,0)" class="fanhui"></a>
  </div>
</template>

<script>
import axios from 'axios';
import * as XLSX from 'xlsx';
import Header from '@/components/header.vue';
import Footer from '@/components/footer.vue';
import { categorysortPage, articleList, bannerList, memberPageList, websiteList } from '@/api/reqFetch.js';
export default {
  name: '',
  layout: '',
  components: {
    Footer,
    Header,
  },
  data() {
    return {
      screenheight: '',
      aboutList: [
        {
          img: '',
          title: '',
        },
      ],

      selId: '1',
      list: [],
      newList: [],
      newList1: [],
      jicenglist: [],
      tabList: [],
      selName: '全部',
      selid: '0',
      talentList: [],
      companyList: [],
      tableData: [],
      indexData: 0,
      pageNum: 4,
      bannerList: [],
      infoList1: [],
      infoList2: [],
      infoList3: [],
      index: 0,
      companyData: {},
      showPhone: false,
      adData: {},
      adData2: {},
      centerrightList: [],
      bottomList: [],
      activeIndex: 0,
      topBanner: '',
      centerBanner: '',
      detailLoading: false,
      subNewsListMap: {},
      showAd5: true, // 控制浮窗显示
      isHover: false, // 控制关闭按钮显示
      ad5X: 0, // 广告的 x 坐标
      ad5Y: 0, // 广告的 y 坐标
      ad5SpeedX: 0.5, // 广告在 x 轴的移动速度

      ad5SpeedY: 0.5, // 广告在 y 轴的移动速度
      ad5Interval: null // 定时器
    };
  },

  mounted() {
    this.getCategorysortPage1();
    this.getCategorysortPage();

    this.getBannerList();
    this.getMemberPageList();
    this.getWebsiteList();
    this.getBanners();
    this.startAd5Movement();
  },
  beforeDestroy() {
    this.stopAd5Movement();
  },

  methods: {
    goAd() {
      this.$router.push({
        name: 'adList',
      })
      this.closeAd5()
    },
    closeAd5() {
      this.showAd5 = false; // 关闭浮窗
      this.stopAd5Movement();
    },
    startAd5Movement() {
      this.ad5Interval = setInterval(() => {
        const ad5 = this.$refs.ad5;
        if (!ad5) return;

        const windowWidth = window.innerWidth;
        const windowHeight = window.innerHeight;
        const ad5Width = ad5.offsetWidth;
        const ad5Height = ad5.offsetHeight;

        // 更新广告位置
        this.ad5X += this.ad5SpeedX;
        this.ad5Y += this.ad5SpeedY;

        // 检查边界碰撞
        if (this.ad5X <= 0 || this.ad5X + ad5Width >= windowWidth) {
          this.ad5SpeedX = -this.ad5SpeedX; // 反转 x 轴速度
        }
        if (this.ad5Y <= 0 || this.ad5Y + ad5Height >= windowHeight) {
          this.ad5SpeedY = -this.ad5SpeedY; // 反转 y 轴速度
        }

        // 应用新位置
        ad5.style.left = `${this.ad5X}px`;
        ad5.style.top = `${this.ad5Y}px`;
      }, 10);
    },
    stopAd5Movement() {
      clearInterval(this.ad5Interval);
      this.ad5Interval = null;
    },
    handleMouseEnter() {
      console.log('移入')
      this.isHover = true;
      this.stopAd5Movement();
    },
    handleMouseLeave() {
      console.log('移出')
      this.isHover = false;
      this.startAd5Movement();
    },
    handleSlideChange(index) {
      this.activeIndex = index;
    },
    getCategorysortPage() {
      categorysortPage({
        pos: 'centerright',
      }).then(res => {
        this.centerrightList = res.data;
        this.selId = res.data[0].categoryCode;
        this.getNewList();
      });
    },
    getCategorysortPage1() {
      categorysortPage({
        pos: 'bottom',
      }).then(res => {
        this.bottomList = res.data;
        this.detailLoading = true;
        setTimeout(() => {
          this.getNewList1(0, res.data[0].categoryCode);
          this.getNewList1(1, res.data[1].categoryCode);
          this.getNewList1(2, res.data[2].categoryCode);
        }, 500);
      });
    },

    changePhone(val) {
      this.showPhone = val;
    },
    imgLoad() {
      this.$nextTick(() => {
        this.screenheight = this.$refs.bannerHeight[0].height + 'px';
      });
    },
    goProDetail(id) {
      const route = this.$router.resolve({
        path: '/productDetail',
        query: {
          id: id,
        },
      });
    },
    // 跳转对应列表
    goNewList(level, type) {
      this.$router.push({
        path: '/newList',
        query: {
          level: level,
          type: type,
          static: true
        },
      })
    },
    goMore(url) {
      const route = this.$router.resolve(url);
    },
    goDetail(id, categoryName, url) {
      if (url) {
        window.open(url, '_blank');
        return
      }
      // 将 categoryName 转换为字符串类型
      categoryName = String(categoryName);
      if (categoryName === '保险史话' || categoryName === '学会纪实') {
        const route = this.$router.resolve({
          path: '/productDetail',
          query: {
            id: id,
          },
        });
        window.open(route.href, '_blank');
      } else {
        const route = this.$router.resolve({
          path: '/context',
          query: {
            id: id,
          },
        });
        window.open(route.href, '_blank');
      }
    },
    // goProDetail(id) {
    // 	const route = this.$router.resolve({
    // 		path: '/productDetail',
    // 		query: {
    // 			id: id
    // 		}
    // 	});
    // 	window.open(route.href, '_blank');
    // },
    goHref(url) {
      window.open(url);
    },

    getBannerList() {
      bannerList({}).then(res => {
        this.bannerList = res.rows;
      });
    },
    changeTab(id, name) {
      this.selName = name;
      this.selid = id;
      this.init();
    },

    getBanners() {
      articleList({
        pageNum: 1,
        pageSize: 1,
        status: 1,
        categoryCode: '1000001',
      }).then(res => {
        if (res.rows.length > 0) {
          this.centerBanner = res.rows[0].image;
        }
      });
    },
    getNewList(categoryCode) {
      articleList({
        pageNum: 1,
        pageSize: 10,
        status: 1,
        categoryCode: this.selId,
      }).then(res => {
        this.newList = res.rows;
      });
    },
    getNewList1(type, categoryCode) {
      articleList({
        pageNum: 1,
        pageSize: 6,
        status: 1,
        categoryCode: categoryCode,
      }).then(res => {
        this.detailLoading = false
        console.log(type, categoryCode)
        this.bottomList[type].newList = res.rows;
        this.subNewsListMap = {
          ...this.subNewsListMap,
          [categoryCode]: res.rows
        }
      });
    },
    getMemberPageList() {
      //类型 1 产险 2 寿险
      memberPageList({
        pageNum: 1,
        pageSize: 99,
        memberType: '1',
      }).then(res => {
        this.infoList1 = res.rows;
      });
      memberPageList({
        pageNum: 1,
        pageSize: 99,
        memberType: '2',
      }).then(res => {
        this.infoList2 = res.rows;
      });
    },
    getWebsiteList() {
      websiteList({
        pageNum: 1,
        pageSize: 20,
      }).then(res => {
        this.companyList = res.rows;
      });
    },
    pros_hover(id) {
      this.selId = id;
      this.getNewList();
    },
    goMore(url) {
      this.$router.push(url);
    },
    // goDetail(id) {
    // 	this.$router.push({
    // 		path: '/context',
    // 		query: {
    // 			id: id
    // 		}
    // 	})
    // },
    goqyDetail(id) {
      const route = this.$router.resolve({
        path: '/context',
        query: {
          id: id,
        },
      });
      window.open(route.href, '_blank');
    },
  },
};
</script>

<style scoped>
.el-carousel {
  width: 100%;
}

.logo-img {
  width: 180px;
  height: 55px;
  flex-shrink: 0;
}

.slider-wrapper {
  overflow: hidden;
}

.slider {
  display: flex;
  width: 600%;
  /* 设置合适的宽度 */
  animation: scroll 260s linear infinite;
  /* 调整时间以匹配图片数量和滚动速度 */
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }

  /* 图片宽度总和的负值 */
}

.custom-carousel {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.slide-content {
  position: relative;
  width: 100%;
  height: 100%;
}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

/* 	.caption {
		position: absolute;
		height: 60px; line-height:60px; overflow: hidden;
		color: #fff;
		text-align: left;
		width: 100%;
		background: linear-gradient(to right, rgba(0, 0, 0, 0.8), transparent);
		display: flex;
		z-index: 9;
		bottom: 0;
		padding: 20px;
		
		justify-content: space-between;
		align-items: center;
	} */

/* 自定义指示器样式 */
.custom-indicators {
  z-index: 2;
  display: flex;
}

.indicator-item {
  width: 8px;
  height: 8px;
  margin: 0 8px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s;
}

.indicator-item.is-active {
  background-color: #fff;
}

/* 覆盖element-ui默认样式 */
/deep/ .el-carousel__arrow {
  background-color: rgba(0, 0, 0, 0.3) !important;
}

/deep/ .el-carousel__arrow:hover {
  background-color: rgba(0, 0, 0, 0.6) !important;
}

.main_c_placeholder {
  display: flex;
  flex-direction: column;
  gap: 10px;

  li {
    width: 100%;
    height: 30px;
    background-color: #f0f0f0;
  }
}

.swiper-title-home {
  /* 显示1行，多余... */
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ad5 {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}

.close-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
  background-color: #ff4444;
  border-radius: 50%;
  text-align: center;
  line-height: 18px;
  cursor: pointer;
  font-size: 16px;
  color: #fff;
}

.ad5 img {
  display: block;
  width: 150px;
  cursor: pointer;
}

.ad {
  text-align: center;
}

.ad img {
  width: 1200px;
  cursor: pointer;
}
</style>
